import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 1720px;
`;

export const PageTitle = styled.h1`
  font-size: 3rem;
  color: #1a1a32;
  font-weight: 600;
`;

export const ScreenHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding: 20px 40px;
  background-color: #fff;
`;

export const Separator = styled.div`
  min-height: 30px;
`;

export const CardHeader = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
`;

export const CardTitle = styled.h3`
  min-width: max-content;
  margin: 0 40px 0 0;
  font-size: 2.4rem;
  color: #17191c;
  font-weight: 600;
`;

export const LeftHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const DropdownWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
`;

export const RightHeader = styled.div`
  width: 60%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
`;

export const CardContent = styled.div``;

export const RegularText = styled.span`
  font-size: 1.6rem;
`;

export const ErrorWrapper = styled.div`
  display: flex;
  color: black;
  justify-content: center;
`;
